import { createTypedHooks } from 'easy-peasy';
import type { StoreModel } from '.';

export const { useStoreActions, useStoreDispatch, useStoreState } = createTypedHooks<StoreModel>();
